export default __webpack_public_path__ + "0bd05c27b37e7432a037a995a3039c32.jpg";